export default __webpack_public_path__ + "8cd362b1ba7736f217dca93af08add57.png";